// components/features/entreprises/EntrepriseList.tsx

import { Entreprise } from '../../../types/features/Entreprise';
import TableList, { SelectAction } from '../../ui/TableList';
import EntrepriseRow from './EntrepriseRow';

interface EntrepriseListProps {
  entreprises: Entreprise[];
  onAction: (entreprise: Entreprise) => void;
  onSelectEntreprises?: (selectedEntreprises: Entreprise[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function EntrepriseList({
  entreprises,
  onAction,
  onSelectEntreprises,
  selectable = false,
  selectActions
}: EntrepriseListProps) {
  const columns = [
    { header: "Entreprise", className: "w-2/5" },
    { header: "Abonnement", className: "hidden sm:table-cell w-1/6" },
    { header: "Téléphone", className: "hidden md:table-cell w-1/6" },
    { header: "Pays", className: "hidden lg:table-cell w-1/6" },
    { header: "Créée le", className: "hidden xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={entreprises}
      columns={columns}
      getId={(entreprise) => entreprise.id}
      onAction={onAction}
      onSelectItems={onSelectEntreprises}
      selectable={selectable}
      emptyMessage="Aucune entreprise trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(entreprise, isSelected, onSelect) => (
        <EntrepriseRow
          key={entreprise.id}
          entreprise={entreprise}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}